
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.335 5.83a.75.75 0 00-.67 0l-8 4a.75.75 0 000 1.34l8 4a.75.75 0 00.67 0l8-4a.75.75 0 000-1.34l-8-4zM12 13.661L5.677 10.5 12 7.339l6.323 3.161L12 13.662zm-7.665.167a.75.75 0 10-.67 1.342l8 4a.75.75 0 00.67 0l8-4a.75.75 0 10-.67-1.342L12 17.661 4.335 13.83z"}})])
          )
        }
      }
    